import {
  call,
  all,
  takeLatest,
  put,
} from 'redux-saga/effects';
import {
  CHANGE_MAIN_MATCH, CHANGE_LAST_MATCH, CHANGE_HOTD_MATCH,
} from 'constants/actions';
import pollTimelineDelta from './timelinedelta';
import pollTimeline from './timeline';
import pollMatchInfo from './matchinfo';
import pollMatchDetails from './matchdetails';
import pollTournamentLiveTable from './tournamentlivetable';
import pollStatsSeasonOverUnder from './statsSeasonOverUnder';
import pollStatsMatchOverUnder from './statsMatchOverUnder';
import pollStatsSeasonGoals from './statsSeasonGoals';
import pollStatsMatch from './statsMatchSituation';
import pollStatsTeamLastX from './statsTeamLastX';
import pollOdds from './odds';
import pollStatsTeamVersus from './statsTeamVersus';
import pollStatsTeamWiningPct from './statsTeamWinningPercent';
import pollStatsTeamInfo from './statTeamInfo';
import pollFunFact from './funfacts';
import { bettingSuggestionsResetToInitialState } from '../../actions/components';
import pollBetstopConfig from './betstop';
import pollFourSightContent from './foursightMatchTickers';
import pollClientMatchId from './clientMatchId';
import pollMatchMarketsConfig from './matchMarkets';
import pollBSConfig from './bettingsSuggestions';

function* pollFishnet(action) {
  try {
    const { payload: matchId } = action;

    const live = true;

    if (matchId) {
      yield all([
        call(pollMatchInfo, matchId),
        call(pollBetstopConfig, matchId, live),
        call(pollMatchMarketsConfig, matchId, live),
        call(pollBSConfig, matchId, live),
        call(pollOdds, matchId, live),
        call(pollStatsTeamLastX, matchId),
        call(pollMatchDetails, matchId),
        call(pollTimelineDelta, matchId),
        call(pollTournamentLiveTable, matchId),
        call(pollStatsSeasonOverUnder, matchId),
        call(pollStatsSeasonGoals, matchId),
        call(pollStatsMatchOverUnder, matchId),
        call(pollStatsMatch, matchId),
        call(pollTimeline, matchId),
        call(pollClientMatchId, matchId),
        call(pollStatsTeamVersus, matchId),
        call(pollStatsTeamWiningPct, matchId),
        call(pollStatsTeamInfo, matchId),
        call(pollFourSightContent, matchId),
      ]);
    }
  } catch (error) {
    yield put(bettingSuggestionsResetToInitialState());
  }
}

function* lastMatchPoller(action) {
  const { payload: matchId } = action;

  if (matchId) {
    yield call(pollMatchInfo, matchId);
    yield all([
      call(pollBetstopConfig, matchId),
      call(pollOdds, matchId),
      call(pollTimelineDelta, matchId),
      call(pollClientMatchId, matchId),
    ]);
  }
}

function* HOTDPoller(action) {
  const { payload: matchId } = action;

  if (matchId > 0) {
    yield all([
      call(pollMatchInfo, matchId),
      call(pollBetstopConfig, matchId, false),
      call(pollMatchMarketsConfig, matchId, false),
      call(pollOdds, matchId, false),
      call(pollFunFact, matchId, false),
      call(pollClientMatchId, matchId),
      call(pollStatsTeamInfo, matchId, false),
    ]);
  }
}

export default function* fishnetSaga() {
  yield takeLatest([CHANGE_MAIN_MATCH], pollFishnet);
  yield takeLatest([CHANGE_LAST_MATCH], lastMatchPoller);
  yield takeLatest([CHANGE_HOTD_MATCH], HOTDPoller);
}
